module.exports = "<td class=\"empty-view_text\" colspan=\"{{colspan}}\">{{text}}</td>";